import React from 'react';

export const LinkedinLogo = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="20" cy="20" r="20" fill="#EAF3EF" />
    <path
      d="M14.94 13C14.9397 13.5305 14.7288 14.0391 14.3535 14.4139C13.9782 14.7888 13.4694 14.9993 12.939 14.999C12.4086 14.9988 11.9 14.7878 11.5251 14.4125C11.1502 14.0373 10.9397 13.5285 10.94 12.998C10.9403 12.4676 11.1512 11.959 11.5265 11.5841C11.9018 11.2092 12.4106 10.9988 12.941 10.999C13.4714 10.9993 13.98 11.2103 14.3549 11.5855C14.7298 11.9608 14.9403 12.4696 14.94 13ZM15 16.48H11V29H15V16.48ZM21.32 16.48H17.34V29H21.28V22.43C21.28 18.77 26.05 18.43 26.05 22.43V29H30V21.07C30 14.9 22.94 15.13 21.28 18.16L21.32 16.48Z"
      fill="#343435"
    />
  </svg>
);
